import React, { lazy, Suspense } from "react";
import Select from 'react-select';
import Loader from '../../../Loader';
import ViewThyroid from "./ViewThyroid";
import ViewBloodPressure from "./ViewBloodPressure";
import ViewBloodSugar from "./ViewBloodSugar";
// import AddPregnancyVitals from '../PregnancyVitalsForm/AddPregnancyVitals';

const vitalsOptions = [
  { label: "Thyroid", value: 1 },
  { label: "Blood Sugar", value: 2 },
  { label: "Blood Pressure", value: 3}
]

class ViewPregnancyVitals extends React.Component {
  state = {
    diseaseType: vitalsOptions[0],
    // loading: true
  };

  componentDidMount() {

  }

  handleDiseaseChange = selectedOption => {

    this.setState(prevState => ({ 
      diseaseType: selectedOption 
    }));
  };

  renderComponent = () => {

    let diseaseType = this.state.diseaseType;
  
    if (diseaseType['label'] === "Thyroid") {
      return <ViewThyroid disease={diseaseType}/>;
    }
    if (diseaseType['label'] === "Blood Sugar") {
      return <ViewBloodSugar disease={diseaseType}/>;
    }
    if (diseaseType['label'] === "Blood Pressure") {
      return <ViewBloodPressure disease={diseaseType}/>;
    }
  };

  render() {

    // if(this.state.loading == true) {
    //   return (
    //     <Loader />
    //   )
    // }
    const { diseaseType } = this.state;
    return (
      <div>
        <div className="row my-4">
          <div className="col-md-3">
            <Select 
              options={vitalsOptions}
              value={diseaseType}
              onChange={this.handleDiseaseChange}
            />
          </div>
        </div>        
        {this.renderComponent()}

        {/* <Form className="row mt-2">
          <FormGroup className="col-3">
            <Input
              type="select"
              style={{ borderLeft: "4px solid #62c2de" }}
              name="deseaseType"
              onChange={this.changeHandler}
            >
              <option>Thyroid</option>
              <option>Blood Sugar</option>
              <option>Blood Pressure</option>
            </Input>
          </FormGroup>
        </Form>
        {this.renderComponent()} */}
        {/* <ViewPregnancyVitalsThyroid />
        <PregnancyVitalsButton /> */}
        {/* <div className="text-center mt-4">
          <Button
            className="btn text-center "
            tag={Link}
            to={"/addpregnancyvitals"}
          >
            <i className="fa fa-plus-circle mr-2" /> Add New Record
          </Button>
        </div> */}
      </div>
    );
  }
}

export default ViewPregnancyVitals;



// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/PregnancyVitals/PregnancyVitalsView/ViewPregnancyVitals.js